import React from "react";
import styled from "@emotion/styled";
import { Button as BaseButton, ButtonProps } from "../Button";
import BaseLeftTuft from "@ecologi/assets/icons/grass-tuft-left.svg";
import BaseRightTuft from "@ecologi/assets/icons/grass-tuft-right.svg";

const ButtonWrapper = styled.div`
  position: relative;
  width: 188px;
  display: flex;
  justify-content: center;
  margin: auto;
`;

const Button = styled(BaseButton)`
  white-space: nowrap;
  width: 188px;
  max-height: 50px;
  @media ${(props) => props.theme.bp.mobileUp} {
    width: 197px;
  }
`;

const LeftTuft = styled(BaseLeftTuft)`
  position: absolute;
  bottom: -6px;
  z-index: 2;
  left: -20px;
`;

const RightTuft = styled(BaseRightTuft)`
  position: absolute;
  right: -21px;
  bottom: -6px;
  z-index: 1;
`;

export const TuftyButton = ({ text, onClick, ...props }: ButtonProps) => {
  return (
    <ButtonWrapper>
      <LeftTuft />
      <Button text={text} onClick={onClick} primary {...props} />
      <RightTuft />
    </ButtonWrapper>
  );
};
